exports = module.exports = require("../../../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".FormInner{max-width:800px;margin:0 auto}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAIA,WACE,eAAA,CACA,aAAA","file":"styles.scss","sourcesContent":["$theme: zam;\n@import \"../../../../../../scss/mixins/breakpoints.scss\";\n@import \"../../../../../../scss/variables.scss\";\n\n.FormInner {\n  max-width: 800px;\n  margin: 0 auto;\n}\n"]}]);

// Exports
exports.locals = {
	"colorPrimary": "#4ca94d",
	"FormInner": "FormInner"
};